import { render, staticRenderFns } from "./ops-manager-allocation.vue?vue&type=template&id=5e996ca6&"
import script from "./ops-manager-allocation.vue?vue&type=script&lang=js&"
export * from "./ops-manager-allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports